export class LqdCarouselStackHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initCarousel();

  }

  getDefaultSettings() {
    return {
      selectors: {
        carouselElement: '.lqd-carousel-stack',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $carouselElement: this.$element.find(selectors.carouselElement),
    }
  }

  initCarousel() {

    this.elements.$carouselElement.liquidCarouselStack();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCarouselDestroy();

  }

  handleCarouselDestroy() {

    if ( ! this.elements.$carouselElement.length ) return;

    const carouselData = this.elements.$carouselElement.data('plugin_liquidCarouselStack');

    if ( carouselData ) {
      carouselData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdCarouselStackHandler, { $element } );
}; 